<template>
  <div class="wspo-tour-description">
    <div class="wspo-tour-head-title">{{ data.name }}</div>
    <div
      class="wspo-description-main"
      v-if="data.description_m"
      v-html="unescape(data.description_m)"
    ></div>
    <div
      class="wspo-description-paragraph"
      v-for="(item, index) in paragraphs"
      :key="index"
    >
      <div
        class="wspo-paragraph-title wspo-icon-after"
        v-if="
          data.description_t &&
            data.description_t[index] &&
            data.description_t[index].trim().length > 0
        "
        @click="showParagraph"
      >
        {{ data.description_t[index] }}
      </div>
      <div
        class="wspo-paragraph-title wspo-icon-after"
        v-else
        @click="showParagraph"
      >
        О курорте {{ index + 1 }}
      </div>
      <div class="wspo-paragraph-content" v-html="unescape(item)"></div>
    </div>
    <div class="wspo-description-paragraph" v-if="data.description_hotel">
      <div
        class="wspo-paragraph-title wspo-icon-after wspo-icon wspo-paragraph-icon-hotel"
        @click="showParagraph"
      >
        Об отеле
      </div>
      <div
        class="wspo-paragraph-content"
        v-html="unescape(data.description_hotel)"
      >
        Об отеле
      </div>
    </div>
    <div class="wspo-description-paragraph" v-if="data.description_room">
      <div
        class="wspo-paragraph-title wspo-icon-after wspo-icon wspo-paragraph-icon-room"
        @click="showParagraph"
      >
        В номерах
      </div>
      <div
        class="wspo-paragraph-content"
        v-html="unescape(data.description_room)"
      >
        Об отеле
      </div>
    </div>
    <div class="wspo-description-paragraph" v-if="data.description_feed">
      <div
        class="wspo-paragraph-title wspo-icon-after wspo-icon wspo-paragraph-icon-feed"
        @click="showParagraph"
      >
        Питание
      </div>
      <div
        class="wspo-paragraph-content"
        v-html="unescape(data.description_feed)"
      >
        Об отеле
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Description',
  props: {
    data: [Object, null]
  },
  computed: {
    paragraphs() {
      return this.data.description_p.filter(p => p.trim().length);
    }
  },
  methods: {
    unescape(text) {
      return text
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&amp;/g, '&')
        .replace(/&nbsp;/g, ' ')
        .trim();
    },
    showParagraph(e) {
      e = e || window.event;
      e.target.classList.toggle('wspo-open');
      e.target.nextElementSibling.classList.toggle('wspo-open');
    }
  }
};
</script>

<style scoped>
.wspo-tour-head-title {
  font-size: 22px;
  padding: 8px 18px;
}
.wspo-description-main {
  padding: 8px 18px;
}
.wspo-paragraph-title {
  font-size: 18px;
  padding: 4px 0;
  color: var(--color-main);
  cursor: pointer;
  display: flex;
  align-items: center;
}
.wspo-paragraph-title:after {
  color: var(--color-main);
  margin-left: 8px;
  font-size: 14px;
  content: '\f078';
  display: block;
  transition: transform 0.3s;
}
.wspo-description-paragraph.wspo-open {
  border-top: 8px solid var(--color-alt-5);
}
.wspo-description-paragraph {
  background-color: var(--color-paper);
  padding: 8px 18px;
  margin: 2px 0;
}
.wspo-paragraph-content {
  padding: 4px 0;
  display: none;
}
.wspo-paragraph-content.wspo-open {
  display: block;
}
.wspo-paragraph-title.wspo-open:after {
  transform: rotate(-180deg);
  transition: transform 0.3s;
}
.wspo-paragraph-icon-hotel:before,
.wspo-paragraph-icon-room:before,
.wspo-paragraph-icon-feed:before {
  font-size: 22px;
  margin-right: 24px;
}
.wspo-paragraph-icon-hotel:before {
  content: '\f594';
}
.wspo-paragraph-icon-room:before {
  content: '\f52b';
}
.wspo-paragraph-icon-feed:before {
  content: '\f725';
}
</style>
